import React from "react"

import { ButtonProps } from "@mui/material"
import { useTranslation } from "react-i18next"

import Dialog from "../../../../common/dialog/dialog"

interface IDialogEditJob {
  isOpen: boolean
  isLoading: boolean
  onClose: () => void
  onDelete: () => void
  children: React.ReactNode
  actionAcceptButtonProps: ButtonProps
  currentTab?: number
}

const DialogEditJob = ({
  onDelete,
  isOpen,
  isLoading,
  onClose,
  children,
  actionAcceptButtonProps,
  currentTab = 0,
}: IDialogEditJob) => {
  const { t } = useTranslation()

  return (
    <Dialog
      titleText={t("jobs.editJob")}
      open={isOpen}
      isLoading={isLoading}
      contentWrapperProps={{ px: "24px" }}
      onClose={onClose}
      desktopMaxWidth="1040px"
      tabletMaxWidth="534px"
      actionAcceptText={"Save"}
      onDeleteClick={onDelete}
      customActionButtonsSlot={currentTab !== 0 ? null : undefined}
      actionAcceptButtonProps={actionAcceptButtonProps}
    >
      {children}
    </Dialog>
  )
}
export default DialogEditJob
